export class Message {
  public type: number;
  public id: number;
  public senderId: number;
  public senderName: string;
  public senderProfileImgSrc: string;
  public senderTipScore: number;
  public sendTime: string;
  public content: string;
  public imgSrc: string;
  public replyMessage: Message;
  public censored: boolean = false;
  public tempCensored: boolean = false;
  public display = true;
  public tipPublished = false;
  public senderHighestScore: number;
  public advId: number = Number.MIN_SAFE_INTEGER;
  public alPublishedTipRace: Array<string>;

  constructor(type: number, id: number, senderId: number, senderName: string, senderProfileImgSrc: string, senderTipScore: number,
      sendTime: string, content: string, imgSrc: string, tipPublished: boolean, senderHighestScore: number, advId: number) {
    this.type = type;
    this.id = id;
    this.senderId = senderId;
    this.senderName = senderName;
    this.senderProfileImgSrc = senderProfileImgSrc;
    this.senderTipScore = senderTipScore;
    this.sendTime = sendTime;
    this.content = content;
    this.imgSrc = imgSrc;
    this.tipPublished = tipPublished;
    this.senderHighestScore = senderHighestScore;
    this.advId = advId;
  }

  setPublishedTipRace(alPublishedTipRace: Array<string>) {
    this.alPublishedTipRace = alPublishedTipRace;
  }

  setReplyMessage(replyMessage: Message) {
    this.replyMessage = replyMessage;
  }

  setCensored(censored: boolean) {
    this.censored = censored;
  }

  setTempCensored(tempCensored: boolean) {
    this.tempCensored = tempCensored;
  }

  isCensored() {
    return this.censored || this.tempCensored;
  }

  setDisplay(display: boolean) {
    this.display = display;
  }

  resetAfterSendMsg(): void {
    this.content = "";
    this.replyMessage = null;
    this.imgSrc = "";
  }
}



// WEBPACK FOOTER //
// ./src/model/Message.ts